export default __webpack_public_path__ + "static/media/paypal.c5939809.svg";